import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { AddAccountModal } from '@/components/positions/AddAccountModal'
import { primaryButtonClass } from '@/components/common/formStyles'
import { listAccounts } from '@/lib/accountsApi'
import type { Account } from '@/types/account'

const BROKER_LABELS: Record<string, string> = {
  ibkr: 'Interactive Brokers',
  consors: 'Consorsbank',
  scalable: 'Scalable Capital',
  manual: 'Manuell',
  external: 'External',
}

export function Step2Accounts() {
  const accountsQuery = useQuery({ queryKey: ['accounts'], queryFn: listAccounts })
  const [modalOpen, setModalOpen] = useState(false)

  const accounts = accountsQuery.data ?? []

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="tracked-caps text-sm text-ink">Accounts anlegen</h2>
        <p className="mt-3 max-w-2xl font-mono text-sm leading-6 text-muted">
          Lege für jeden Broker, den du in Sextant verwalten willst, einen Account an. Pro Account:
          Name, Broker-Typ, Konto-Währung. Für BTC bzw. weitere External Assets legt sich Schritt 5
          separat einen <code className="text-ink">external</code>-Account an, falls noch keiner
          existiert.
        </p>
      </div>

      <section className="hairline-y py-5">
        <div className="mb-4 flex items-baseline justify-between">
          <p className="tracked-caps text-[10px] text-faint">
            {accounts.length === 0 ? 'Noch keine Accounts' : `${accounts.length} Account(s)`}
          </p>
          <button type="button" onClick={() => setModalOpen(true)} className={primaryButtonClass}>
            + Account anlegen
          </button>
        </div>

        {accountsQuery.isLoading && <p className="font-mono text-sm text-muted">Lade Accounts…</p>}

        {!accountsQuery.isLoading && accounts.length === 0 && (
          <p className="font-mono text-sm text-faint">
            Mindestens ein Account ist erforderlich, um weiterzugehen.
          </p>
        )}

        {accounts.length > 0 && (
          <ul className="flex flex-col">
            {accounts.map((account: Account) => (
              <li
                key={account.id}
                className="hairline-b flex items-baseline justify-between py-2.5 font-mono text-sm"
              >
                <span className="text-ink">{account.name}</span>
                <span className="flex items-baseline gap-3 text-muted">
                  <span className="tracked-caps text-[10px] text-bernstein">
                    {BROKER_LABELS[account.broker_type] ?? account.broker_type}
                  </span>
                  <span className="text-faint">{account.currency}</span>
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>

      <AddAccountModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  )
}
